
// Import necessary dependencies
import { supabase } from '@/integrations/supabase/client';

// Define local variables used across API functions
export const PRODUCTS_TABLE = 'products';

// Get the current user ID for database operations
export const getUserId = async () => {
  const { data } = await supabase.auth.getSession();
  if (!data.session?.user?.id) {
    console.error('No authenticated user found');
    throw new Error('Authentication required');
  }
  return data.session.user.id;
};
